import type { MapMarker } from '@gpx-spa/geo-domain'
import type L from 'leaflet'

export const leafletMarkerMetadata = new WeakMap<L.Marker, MapMarker>()

export function attachMapMarkerToLeafletMarker(
  leafletMarker: L.Marker,
  mapMarker: MapMarker
): L.Marker {
  leafletMarkerMetadata.set(leafletMarker, mapMarker)
  return leafletMarker
}
